/**
 * Header search overlay — open/close behaviour.
 *
 * Opens from any [data-cs-open] trigger or ⌘K / Ctrl-K; closes on Esc or a
 * backdrop click. The form itself is a plain GET to the site search, so
 * submitting works without this script — it only handles the overlay UX.
 */
export function initSearchOverlay() {
	const overlay = document.getElementById('cs-overlay');
	if (!overlay) return;

	const input = document.getElementById('cs-input');
	const triggers = document.querySelectorAll('[data-cs-open]');
	let lastFocused = null;

	function open() {
		lastFocused = document.activeElement;
		overlay.classList.add('open');
		overlay.setAttribute('aria-hidden', 'false');
		// Focus after the open transition so the caret lands reliably.
		window.setTimeout(() => { if (input) input.focus(); }, 60);
	}

	function close() {
		if (!overlay.classList.contains('open')) return;
		overlay.classList.remove('open');
		overlay.setAttribute('aria-hidden', 'true');
		if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
	}

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => { e.preventDefault(); open(); });
	});

	// Backdrop click (but not clicks inside the panel) closes.
	overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			close();
		} else if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
			e.preventDefault();
			open();
		}
	});
}
